import React from "react";


import {
    InformativeCardComponent
} from "@Components/Elements";


export type LegalElementsListElementType = {
    elementOrderNr?: number | string;
    elementTitle: string;
    elementContent: string;
};


type LegalElementsListElementComponentProps = {
    Element: LegalElementsListElementType;
};


export const LegalElementsListElementComponent:React.FC<LegalElementsListElementComponentProps> = ({
    Element
}) => {


    if (!Element) {
        return null;
    }

    const { elementOrderNr, elementTitle, elementContent } = Element;


    return (
        <InformativeCardComponent
            cardDecoration={{ decorationType: 'orderNr', decorationSource: elementOrderNr?.toString() }}
            cardTitle={elementTitle}
            cardDescription={elementContent}
        />
    );

};


export default LegalElementsListElementComponent;
